<template>
  <transition name="fade" appear>
  <div class="reward col-6 col-md-4 pb-3">
    <div class="card" style="z-index: 0">
      <div class="cover" :class="[!category && reward.picture_thumb_module && !isMultivoucherNotReadyOrder && 'cover-custom-img']"
           v-on="isMultivoucherNotReadyOrder ? {} : { click: () => openDetailsModal() }">
        <img class="card-img-top"
             v-show="imageLoaded"
             @load="imageLoaded = true"
             alt=""
             :src="reward.picture_thumb_module"
        >

        <img class="card-img-top"
             v-show="!imageLoaded"
             alt=""
             src="@/assets/app/media/img/misc/placeholder.png"
        >
      </div>
      <div class="card-body">
        <h6 class="card-title text-center ellipsis" @click="openDetailsModal">
          <span v-if="order" class="d-inline text-date">{{ reward.date_add | date }} </span>
          <span v-else-if="!category && reward.points>0" class="font-ls d-inline">{{ reward.points }} {{pointsSymbol}} </span>
          <span v-encode="reward.name"></span>
        </h6>
        <div class="card-text">
          <div class="m-widget19__action mt-4 d-flex justify-content-center">
            <div v-if="category">
              <button type="button"
                      class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls"
                      @click="emitSelectCategory">
                Zobacz
              </button>
            </div>
            <div v-if="!order && !category && ordersEnabled && !missingPoints">
              <button
                  v-if="reward.type === '0'"
                  type="button" class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls order-button-text"
                  @click="setOrder(reward)">
                <span>Zamów</span>
              </button>
              <button
                  v-else-if="reward.type === '1'"
                  type="button" class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls order-button-text"
                  @click="setDigitalOrder(reward)">
                <span>Zamów</span>
              </button>
              <button
                  v-else-if="reward.type === '2'"
                  type="button" class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls"
                  @click="setVariantsOrder(reward) && setVariantsOrderModalId(reward.id)">
                Wybierz
              </button>
            </div>
            <div v-if="!order && !category && ordersEnabled && missingPoints">
              <button type="button" class="btn m-btn--pill m-btn btn-secondary disabled" disabled>
                Brakuje {{ missingPoints }} {{pointsSymbol}}
              </button>
            </div>
            <div v-if="order && !isMultivoucherNotReadyOrder">
              <button
                  type="button" class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls"
                  @click="showOrder">
                Zobacz
              </button>
            </div>
            <div v-if="order && isMultivoucherNotReadyOrder">
              <button
                  type="button" class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls"
                  disabled>
                W przygotowaniu
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal v-model="isDetailsModalOpen" header-class="border-bottom-0 p-0 m-0" lazy hide-footer centered size="lg">
      <template v-slot:modal-header="{ close }">
        <button type="button" aria-label="Close" class="close mt-1 mr-0" @click="close">×</button>
      </template>
      <div class="row">
        <div class="col-12 text-center">
          <img v-if="reward.picture_thumb_module" class="img-fluid rounded"
               :src="reward.picture_thumb_module" :alt="`Zdjęcie ${reward.name}`">
        </div>
        <div class="col-12">
          <h5 class="mt-4">
            <span v-if="order" class="text-date">{{ reward.date_add | date }} </span>
            <span v-else-if="!category && reward.points>0" class="font-ls">{{ reward.points }} {{pointsSymbol}} </span>
            <span v-encode="reward.name"></span>
          </h5>
          <div v-if="reward.description" class="mt-4" v-html="reward.description"></div>
        </div>
        <div class="col-12">
          <div class="m-widget19__action mt-4 d-flex justify-content-center">
            <div v-if="order && !isMultivoucherNotReadyOrder">
              <button type="button"
                      class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls"
                      @click="showOrder">
                Zobacz
              </button>
            </div>
            <div v-else-if="order && isMultivoucherNotReadyOrder">
              <button type="button"
                      class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls"
                      disabled
              >
                W przygotowaniu
              </button>
            </div>
            <div v-else-if="category">
              <button type="button"
                      class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls"
                      @click="emitSelectCategory">
                Zobacz
              </button>
            </div>
            <div v-else-if="!order && !category && reward.type!=='2' && ordersEnabled && !missingPoints">
              <button
                  v-if="reward.type === '0'"
                  type="button" class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls order-button-text"
                  @click="setOrderCloseModal">
                <span>Zamów</span>
              </button>
              <button
                  v-else
                  type="button" class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls order-button-text"
                  @click="setDigitalOrder(reward)">
                <span>Zamów</span>
              </button>
            </div>
            <div v-else-if="reward.type ==='2'">
              <button
                  type="button" class="btn m-btn--pill m-btn m-btn--custom btn-ls m-btn--hover-ls"
                  @click="setVariantsOrder(reward) && setVariantsOrderModalId(reward.id)">
                Wybierz
              </button>
            </div>
            <div v-else-if="!category && ordersEnabled && missingPoints">
              <button type="button" class="btn m-btn--pill m-btn btn-secondary disabled" disabled>
                Brakuje {{ missingPoints }} {{pointsSymbol}}
              </button>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
  </transition>
</template>

<script>
import {mapActions, mapState} from 'vuex'
import Encode from "@/directives/encode";

export default {
  name: "RewardGridItem",
  props: {
    reward: Object,
    category: Boolean,
    order: Boolean,
  },
  directives: {
    Encode
  },
  filters: {
    date(value) {
      return value.split(' ')[0].split('-').reverse().join('.');
    }
  },
  data() {
    return {
      imageLoaded: false,
      isDetailsModalOpen: false,
    }
  },
  methods: {
    ...mapActions([
      'setOrder',
      'setDigitalOrder',
      'setVariantsOrder',
      'setDigitalOrderModalId',
      'setMaterialOrderModalId',
      'setVariantsOrderModalId',
    ]),
    setOrderCloseModal() {
      this.setOrder(this.reward);
      this.isDetailsModalOpen = false;
    },
    openDetailsModal() {
      if (this.category) {
        this.emitSelectCategory();
      } else {
        this.isDetailsModalOpen = true;
      }
    },
    previewImg() {
      if (this.reward.picture) {
        this.$imgPreview({
          img: this.reward.picture,
        })
      }
    },
    emitSelectCategory() {
      this.isDetailsModalOpen = false;
      let push = { name: 'RewardsByCategoryPage', params: { id: this.reward.hid } };

      if (this.returnPage) {
        push.query = {
          return: this.returnPage,
          status: this.returnStatus,
          showOnPage: this.returnShowOnPage
        };
      }
      this.$router.push(push)
    },
    showOrder() {
      if (this.reward.reward_type === '1') {
        this.setDigitalOrderModalId(this.reward.id)
      } else if (this.reward.reward_type === '0') {
        this.setMaterialOrderModalId(this.reward.id)
      } else if (this.reward.reward_type === '2') {
        this.setVariantsOrderModalId(this.reward.id)
      }
    }
  },
  computed: {
    ...mapState({
      saldo: state => state.auth.user.saldo,
      stateUser: state => state.auth.user,
      ordersEnabled: state => state.settings.rewardsOrders === "1",
      pointsConfig: state => state.settings.points,
      pointsSymbol() {
        return this.pointsConfig.symbol ? this.pointsConfig.symbol : 'pkt.';
      }
    }),
    progressBarPercent() {
      return Math.ceil((parseFloat(this.saldo) / parseFloat(this.reward.points)) * 100)
    },
    missingPoints() {
      if (parseFloat(this.reward.points) === 0) {
        return 0;
      }
      const missing = parseFloat(this.reward.points) - parseFloat(this.saldo);

      if (missing <= 0) {
        return 0;
      }

      if (missing === Math.floor(missing)) {
        return Math.floor(missing);
      }

      return missing.toFixed(2);
    },
    isMultivoucherNotReadyOrder() {
      if (this.reward.integration_type !== 'multivoucher') {
        return false;
      }

      if(this.reward.status === "5"){
        return true;
      }

      if (this.reward.details) {
        const order = JSON.parse(this.reward.details);

        return order.product == null && order.order == null;
      }

      return false;
    }
  }
}
</script>

<style scoped>
.shadow {
  background-color: green;
  -webkit-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  -moz-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
}

.ellipsis {
  overflow: hidden;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  display: -webkit-box;
}

.cover {
  cursor: pointer;
  position: relative; /* Not required now */
  float: left;
  -webkit-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  -moz-box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
  box-shadow: inset 0 -56px 30px -30px rgba(0, 0, 0, 0.65);
}

.cover img {
  display: block;
  position: relative;
  z-index: -1;
}

.cover-custom-img:hover {
  background: rgba(1, 1, 1, 0.1);
  cursor: pointer;
  position: relative;
}

.cover-custom-img:hover:before {
  cursor: pointer;
  font-family: "Font Awesome 5 Free", serif;
  font-weight: 900;
  font-size: 60px;
  content: "\F00E";
  color: white;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  margin: auto;
  width: 40px;
  height: 80px;
}

.hidden {
  display: none !important;
}

.card-title {
  cursor: pointer;
  height: 32px;
}

@media screen and (max-width: 767px) {
  .reward {
    padding-left: 7px;
    padding-bottom: 14px !important;
  }

  .reward:nth-of-type(2n + 1) {
    padding-left: 14px;
    padding-right: 7px;
  }
}

.card-body {
  padding-top: 1rem;
  padding-right: 0.5rem;
  padding-left: 0.5rem;
}

.btn-secondary.disabled {
  background-color: #f4f5f8;
}

.text-date {
  color: #c4c5d7;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
